import { ethers } from 'ethers';
import abi from './lotteryAbi.json';
// import distroAbi from './distributionAbi.json';
import erc20Abi from './erc20.json';

import { base } from 'viem/chains';

export const participateInLottery = async (
  wallet: any,
  lotteryId: number,
  tierIndex: number,
  usdvValue: string
) => {
  // console.log('privy payload---', wallet, lotteryId, usdvValue)
  try {
    if (!wallet) throw { data: { message: 'Please connect your wallet' } };
    await wallet?.switchChain(base.id);
    const provider = new ethers.providers.Web3Provider(
      (window as any).ethereum
    );
    const accounts = await provider.listAccounts();
    if (accounts.length === 0) {
      throw { data: { message: 'Please connect your wallet' } };
    }
    const signer = provider.getSigner();
    const contract = new ethers.Contract(
      process.env.REACT_APP_LOTTERY_CONTRACT_ADDRESS ?? '',
      abi,
      signer
    );
    const usdcContract = new ethers.Contract(
      process.env.REACT_APP_USDC_ADDRESS ?? '',
      erc20Abi,
      signer
    );
    const value = await contract?.lotteryParticipants(lotteryId, accounts[0]);
    console.log('value---', parseInt(value));
    if (parseInt(value) > 0)
      throw {
        data: { message: 'You have already participated in this lottery' },
      };
    const allowance = await usdcContract?.allowance(
      accounts[0],
      process.env.REACT_APP_LOTTERY_CONTRACT_ADDRESS
    );
    console.log('allowance--', allowance.toString());
    const tokenBalance = await usdcContract?.balanceOf(accounts[0]);
    const decimals = await usdcContract?.decimals();
    console.log(
      'allowance---',
      parseInt(allowance),
      parseInt(ethers.utils.parseUnits(usdvValue, decimals).toString()),
      tokenBalance.toString()
    );
    console.log(
      ethers.utils.parseUnits(usdvValue, decimals),
      tokenBalance,
      tokenBalance.lt(ethers.utils.parseUnits(usdvValue, decimals))
    );
    if (tokenBalance.lt(ethers.utils.parseUnits(usdvValue, decimals))) {
      throw { data: { message: 'Insufficient Balance' } };
    } else {
      if (allowance.lt(ethers.utils.parseUnits(usdvValue, decimals))) {
        console.log('allowance is less than required');
        const tx = await usdcContract.approve(
          process.env.REACT_APP_LOTTERY_CONTRACT_ADDRESS,
          ethers.utils.parseUnits(usdvValue, decimals)
        );
        await tx.wait();
      }
    }
    console.log(tierIndex, lotteryId);
    const tx = await contract.participateInLottery(lotteryId, tierIndex);
    await tx.wait();
    return tx;
  } catch (err: any) {
    console.log(
      '66666666666666666666666666666666666666',
      err,
      Object.keys(err)
    );
    if (err?.code == 'ACTION_REJECTED') return { error: err.reason };
    return { error: err?.data?.message };
  }
};

import { createPublicClient, http } from 'viem';

const client = createPublicClient({
  chain: base,
  transport: http(), // or use your provider URL: http('https://mainnet.infura.io/v3/YOUR_INFURA_KEY')
});

export const checkAllowanceAndBalance = async (
  lotteryId: number,
  walletAddress: any,
  usdvValue: string
) => {
  try {
    console.log('payload---', lotteryId, walletAddress, usdvValue);
    const value = await client.readContract({
      address: process.env.REACT_APP_LOTTERY_CONTRACT_ADDRESS as `0x${string}`,
      abi: abi,
      functionName: 'lotteryParticipants',
      args: [lotteryId, walletAddress],
    });
    if (value && parseInt(value.toString()) > 0)
      throw {
        data: { message: 'You have already participated in this lottery' },
      };

    const allowance = await client.readContract({
      address: process.env.REACT_APP_USDC_ADDRESS as `0x${string}`,
      abi: erc20Abi,
      functionName: 'allowance',
      args: [walletAddress, process.env.REACT_APP_LOTTERY_CONTRACT_ADDRESS],
    });

    const decimals = await client.readContract({
      address: process.env.REACT_APP_USDC_ADDRESS as `0x${string}`,
      abi: erc20Abi,
      functionName: 'decimals',
      args: [],
    });

    // console.log('test---tokenBalance,decimals,allowance,value,usdvValue---', tokenBalance, decimals, allowance, value, Number(usdvValue))
    // if (
    //   tokenBalance !== null && tokenBalance !== undefined &&
    //   tokenBalance < ethers.utils.parseUnits(usdvValue, decimals as bigint)
    // ) {
    //   throw { data: { message: 'Insufficient Balance' } };
    // } else {
    if (
      allowance !== null &&
      allowance !== undefined &&
      allowance < ethers.utils.parseUnits(usdvValue, decimals as bigint)
    ) {
      return { data: { code: 'callApprove', decimals: decimals } };
    } else {
      return { data: { code: 'success' } };
    }
    // }
  } catch (error) {
    return error as {
      data: { message?: string; code?: string; decimals?: any };
    };
  }
};

export const getTokenBalance = async (walletAddress: any) => {
  try {
    const decimals = await client.readContract({
      address: process.env.REACT_APP_USDC_ADDRESS as `0x${string}`,
      abi: erc20Abi,
      functionName: 'decimals',
      args: [],
    });
    const tokenBalance = await client.readContract({
      address: process.env.REACT_APP_USDC_ADDRESS as `0x${string}`,
      abi: erc20Abi,
      functionName: 'balanceOf',
      args: [walletAddress],
    });
    if (tokenBalance !== undefined && tokenBalance !== null) {
      return ethers.utils.formatUnits(tokenBalance.toString(), decimals as any);
    }
  } catch (error) {
    return '0.0';
  }
};

export const getEthBalance = async (walletAddress: any) => {
  try {
    const balance = await client.getBalance({ address: walletAddress });
    if (balance !== undefined && balance !== null) {
      return ethers.utils.formatUnits(balance.toString(), 18);
    }
  } catch (error) {
    return '0.0';
  }
};

// export const getProjectConfig = async (roundId: number) => {
//   try {
//     const config = await client.readContract({
//       address: '0xa5B1241ADD242A3360f7B51b3dDf187C5EbFD4F4' as `0x${string}`,
//       abi: distroAbi,
//       functionName: 'projectConfig',
//       args: [roundId],
//     });
//       return config;
//   } catch (error) {
//     return false;
//   }
// };
